import { makeStyles } from "@material-ui/core/styles";
import { buildAgendaTheme } from "../../theme/agendaTheme";

const getAgenda = (theme) =>
  theme.agenda || buildAgendaTheme(theme.palette?.type === "dark" ? "dark" : "light");

export const useStyles = makeStyles((theme) => {
  const a = getAgenda(theme);
  const palette = a.palette || {};

  return {
    formField: { marginBottom: theme.spacing(2) },
    actions: { marginTop: theme.spacing(2), display: "flex", gap: theme.spacing(1), justifyContent: "flex-end" },
    // Sin `color-scheme`, el widget nativo datetime-local se pinta en claro sobre el modal oscuro
    nativeDateInput: { "& input": { colorScheme: a.mode } },
    selectPlaceholder: { color: palette.textSecondary },
    connectionSubtitle: { fontSize: 12, color: palette.textSecondary },
    connectionBadge: {
      fontSize: 10,
      padding: "2px 6px",
      borderRadius: 10,
      fontWeight: "bold",
    },
    // Verde WhatsApp de marca, pero con texto oscuro: blanco sobre #25d366 daba 1.9:1
    connectionBadgeOn: { backgroundColor: "#25d366", color: "#0b1220" },
    connectionBadgeOff: { backgroundColor: palette.danger, color: "#fff" },
  };
});
